import React from "react";

const HeroSection = () => {
  return (
    <div className="w-full bg-[#f2efea] py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20">
          <div
            className="text-black text-2xl md:text-4xl font-semibold max-w-full md:max-w-5xl text-center md:text-left"
            style={{ fontFamily: "Blacker Pro Display" }}
          >
            Ready ? Lets Shape Your Next Big Idea.
          </div>

          <button
            className="w-full md:w-auto px-6 py-2 border border-gray-300 text-sm text-gray-800 hover:bg-[#704735] hover:text-white transition-colors font-semibold tracking-widest whitespace-nowrap mt-6 md:mt-0"
            style={{ fontFamily: "Blacker Pro Display" }}
          >
            LET'S CHAT
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
